import React from 'react';
import {Button, ContentState} from '@stripe-internal/connect-embedded-lib';
import {useIntl} from '@sail/intl';
import {messages as AMmessages} from './messages';

type Props = {
  refetchAccount: () => void;
};

export const AccountManagementErrorState: React.FC<Props> = ({
  refetchAccount,
}) => {
  const intl = useIntl();
  return (
    <ContentState
      title={intl.formatMessage(AMmessages.failedToLoad)}
      actions={
        <Button type="primary" onPress={() => refetchAccount()}>
          {intl.formatMessage(AMmessages.tryAgain)}
        </Button>
      }
    />
  );
};
